export const GET_AREAS = 'GET_AREAS';
export const CRUD_AREAS = 'CRUD_AREAS';
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const CLEAN_AREAS_STATE = 'CLEAN_AREAS_STATE';
export const CLEAN_AREAS_ERROR = 'CLEAN_AREAS_ERROR';
export const CHANGE_SETTING_LOCAL = 'CHANGE_SETTING_LOCAL';
export const SET_AREA_DATA = 'SET_AREA_DATA';
export const SET_FETECHING = 'SET_FETECHING';